import React from 'react';

import LayoutViewAppLoading from "./view-app-loading/view-app-loading";
import LayoutViewBusyLoading from "./view-busy-loading/view-busy-loading";

// pohodu eto overlay loading screen dlya item view ....

const debug = false
// const debug = "LayoutViewLoading"

type Props = {

}

type State = {
    display : 'loading' | 'busy' | false
    label   : string | false
}

export default class LayoutViewLoading extends React.Component<Props, State> {



    constructor(props:Props) {
        super(props);

        this.state = {
            display : false,
            label   : false
        }

        gd.layout.viewLoading = this;
    }

    showLoading(callback:callback) {
        return new Promise(async (resolve, reject) => {
            this.setState({display: 'loading'},
                () => {
                    setTimeout(()=>{
                        debug && console.log(debug, 'showLoading state has changed')
                        callback && callback()
                        resolve(true)
                    }, 0)
                }
            )
        })
    }

    // seems like it doesn't work as expected
    async showLoadingAsync() {
        this.setState({display: 'loading'},
            () => {setTimeout(()=>{
                debug && console.log(debug, 'showLoadingAsync state has changed')
                return true
            }, 0)})
    }

    // overlay loading designed as LayoutLoading's showAppBusyAsync, but rendered above the item view
    showBusyAsync(label:string='Please wait') {
        return new Promise((resolve, reject) => {
            this.setState({
                display : 'busy',
                label   : label
            }, () => {
                setTimeout(()=>{
                    debug && console.log(debug, 'showBusyAsync state has changed')
                    resolve(true)
                }, 25)
            })
        })
    }

    hide() {
        this.setState({
            display : false,
            label   : false
        })
    }


    render() {
        switch (this.state.display) {
            case 'loading':
                return <LayoutViewAppLoading />

            case 'busy':
                return <LayoutViewBusyLoading label={this.state.label} />
        }

        return false;
    }
}
